$(document).ready(function()
{
    if ( $('#breadCrumb').length )
    {
        var the_count = $("#breadCrumb li").length;

        if (the_count > 2)
        {
            var hideUntil = the_count - 2;
            $('#breadCrumb li').each(function(idx) {
                if (idx < hideUntil)
                {
                    $(this).addClass("hide-for-small-only");
                }
            });
        }
    }

});